import { CacheUtility } from '@utility/cache';
import { APIPath } from '../constants/api';
import { BaseService } from './base';
import { CRUDService } from './crud';

class ItemBundles extends CRUDService {
  constructor() {
    super(APIPath.bundles);
  }

  byItem = async (itemId, forceRefresh = false) => {
    const url = `${APIPath.bundlesByItem}/${itemId}`;
    const cache = CacheUtility.get(url);
    if (cache && !forceRefresh) {
      return cache;
    }
    const result = await BaseService.get(url);
    CacheUtility.save(url, result);
    return result;
  };

  getInventory = (providerId, itemId) =>
    BaseService.get(`${APIPath.scmProvider}/${providerId}/bundles/${itemId}`);

  saveInventory = (providerId, bundleId, data) =>
    BaseService.put(
      `${APIPath.scmProvider}/${providerId}/bundles/${bundleId}`,
      data,
    );
}

const ItemBundlesService = new ItemBundles();
Object.freeze(ItemBundlesService);
export default ItemBundlesService;
